import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { TextInput } from '@telus-uds/components-web';

const ChannelOrgCode = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  useEffect(() => {
    return () => {
      setFieldData(previousValue => ({ ...previousValue, channelOrgCode: '' }));
    };
  }, []);

  return (
    <TextInput
      type="tel"
      label="Channel Organization Code *"
      pattern="[0-9|a-z|A-Z]{5}"
      maxLength="5"
      value={fieldData.channelOrgCode}
      error={
        'channelOrgCode' in formErrors ? formErrors.channelOrgCode.message : undefined
      }
      onChange={(value) => {
        if (!value)
          setFormErrors({
            ...formErrors,
            channelOrgCode: { message: 'Field is required' }
          });
        else if (!/^[0-9|a-z|A-Z]{5}/.test(value)) {
          setFormErrors({
            ...formErrors,
            channelOrgCode: {
              message: 'Channel Organization Code must be exactly 5 digit'
            }
          });
        } else {
          const errors = { ...formErrors };
          delete errors.channelOrgCode;
          setFormErrors({
            ...errors
          });
        }
        setFieldData(previousValue => ({
          ...previousValue,
          channelOrgCode: value
        }));
      }}
    />
  );
};

ChannelOrgCode.propTypes = {
  formErrors: PropTypes.shape({
    channelOrgCode: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    role: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    contactNumber: PropTypes.string,
    provinces: PropTypes.arrayOf(PropTypes.string),
    channels: PropTypes.arrayOf(PropTypes.string),
    outlet: PropTypes.string,
    cpmsId: PropTypes.string,
    xid: PropTypes.string,
    storeCode: PropTypes.string,
    dealership: PropTypes.arrayOf(PropTypes.string),
    channelOrgCode: PropTypes.string,
    salesManager: PropTypes.string,
    salesManagerEmail: PropTypes.string
  }).isRequired
};

export default ChannelOrgCode;
